import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { CartEventoService } from '@/core/api/sicom-api/servicos/pessoa-juridica/cart-evento/cart-evento.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { CartEventoRequest, CartEventoResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/cart-evento/cart-evento.model';

@Injectable({ providedIn: 'root' })
export class CartEventosServicosService {
    constructor(
        private api: CartEventoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: CartEventoRequest, context?: HttpContext): Observable<CartEventoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
